/**
 * @todo This should be exported from @ftdr/blueprint_core
 * and auto generated based on class names used in component_css
 */
export const CSS_CLASSES = {
  CONTEXT_MENU_ANCHOR_WRAPPER: "context-menu-anchor-wrapper",

  CONTEXT_MENU_LIST: "context-menu-list",

  CONTEXT_MENU_ITEM: "context-menu-item",
  CONTEXT_MENU_ITEM_DEFAULT: "context-menu-item-default",
  CONTEXT_MENU_ITEM_HIGHLIGHTED: "context-menu-item-highlighted",
};
